import { createTheme, ThemeProvider } from '@mui/material'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'
import { PersistGate } from 'redux-persist/integration/react'
import App from './components/App/App'
import { SnackbarComponent } from './components/Base/Snackbar/Snackbar'
import { environment } from './environment'
import './index.scss'
import { loadSidenavAndLogin } from './services/sidenav.service'
import { persistedStore, persistor } from './store'
import themeConfig from './theme/theme-config'

const renderApp = () => {
  const theme = createTheme(themeConfig)
  const rootEl = document.getElementById('app')
  if (!rootEl) throw new Error('Cannot find app root')

  const root = createRoot(rootEl)
  root.render(
    <React.StrictMode>
      <Provider store={persistedStore}>
        <ThemeProvider theme={theme}>
          <PersistGate loading={null} persistor={persistor}>
            <BrowserRouter basename='/'>
              <App />
              <SnackbarComponent />
            </BrowserRouter>
          </PersistGate>
        </ThemeProvider>
      </Provider>
    </React.StrictMode>,
  )
}

console.log(
  `running in realm: ${environment.realm}, sidenav: ${environment.sidenavBaseUrl}`,
)

loadSidenavAndLogin()
  .then(() => {
    renderApp()
  })
  .catch((error) => {
    console.log(error)
    // console.error(`sidenav login failed: ${error}`)
  })
